import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

function normalizeMediaUrl(url) {
  if (!url) return url;
  const clean = String(url)
    .replace(/^https:\/\/https:\/\//, "https://")
    .replace(/^https:\/\/http:\/\//, "http://");
  if (/^\/\//.test(clean)) return `https:${clean}`;
  if (!/^https?:\/\//.test(clean)) return `https://${clean}`;
  return clean;
}

function normalizeItem(item) {
  return {
    ...item,
    imageUrl: normalizeMediaUrl(item.imageUrl),
  };
}

export async function listarSiteMedia() {
  const res = await api.get("/site-media");
  return {
    ...res.data,
    items: (res.data?.items || []).map(normalizeItem),
  };
}

export async function obtenerSiteMediaMap() {
  const { items = [] } = await listarSiteMedia();
  return items.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
  }, {});
}

export async function actualizarSiteMedia(key, payload) {
  const res = await apiAuth.put(`/site-media/${encodeURIComponent(key)}`, payload);
  return normalizeItem(res.data);
}

export async function subirSiteMediaImage(key, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(
    `/site-media/${encodeURIComponent(key)}/image`,
    formData,
  );
  return {
    ...res.data,
    url: normalizeMediaUrl(res.data?.url),
    item: res.data?.item ? normalizeItem(res.data.item) : res.data?.item,
  };
}
